import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 21l18 0","key":"svg-0"}],["path",{"d":"M4 21v-15a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v15","key":"svg-1"}],["path",{"d":"M9 21v-8a3 3 0 0 1 6 0v8","key":"svg-2"}]]

const IconBuildingArch = createReactComponent('outline', 'building-arch', 'BuildingArch', __iconNode);

export default IconBuildingArch;